import CacheDatabase from "./CacheDatabase";
import { CacheManager } from "./CacheManager";
import {FeatureFlags} from "../utils/FeatureFlags";

const STRUCTURED_CACHE_FLAG = "LUMIDS_STRUCTURED_CACHE_ENABLED";

function readFlag(): boolean {
    try {
        const stored = localStorage.getItem(STRUCTURED_CACHE_FLAG);
        if (stored === null) return FeatureFlags.structuredCache;
        return stored === "true";
    } catch (_e) {
        return FeatureFlags.structuredCache;
    }
}

function writeFlag(enabled: boolean): boolean {
    try {
        localStorage.setItem(STRUCTURED_CACHE_FLAG, String(enabled));
    } catch (_e) {
        /* ignore storage errors (private mode, etc.) */
    }
    return enabled;
}

export function isStructuredCacheEnabled(): boolean {
    return readFlag();
}

export function setStructuredCacheEnabled(enabled: boolean): boolean {
    return writeFlag(enabled);
}

/* see docs/EXTRACTED_COMMENTS.md#c001 */
export function canPersistSnapshot(): boolean {
    return CacheManager.instance.canPersist();
}

/* see docs/EXTRACTED_COMMENTS.md#c002 */
export async function killStructuredCache(): Promise<void> {
    try {
        await CacheDatabase.getInstance().wipeAll();
        if (typeof caches !== "undefined") {
            await Promise.allSettled([
                caches.delete("lumids-images"),
                caches.delete("lumids-videos"),
            ]);
        }
    } catch (e) {
        console.warn("[CacheControl] killStructuredCache:", e);
    }
}

export function ensureStructuredCacheFlag(enabled: boolean): void {
    writeFlag(enabled);
}
